export enum TipoDocumentoEnum {
    EVIDENCIA_REPRESENTANTES_LEGALES_1 = 'EVIDENCIA_REPRESENTANTES_LEGALES_1',
    EVIDENCIA_REPRESENTANTES_LEGALES_2 = 'EVIDENCIA_REPRESENTANTES_LEGALES_2',
    CEDULA_IDENTIDAD = 'CEDULA_IDENTIDAD',
    PATENTE_COMERCIAL = 'PATENTE_COMERCIAL',
    EVIDENCIA_VENTAS = 'EVIDENCIA_VENTAS',
    EVIDENCIA_FERIA_EVENTO = 'EVIDENCIA_FERIA_EVENTO',
    ESCRITURA = 'ESCRITURA'
}
